// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edgeEnd {\n  margin-right: -12px;\n  margin-top: -10px !important;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Login/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B","sourcesContent":[".edgeEnd {\n  margin-right: -12px;\n  margin-top: -10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
